import { useState } from 'react';
import styled from 'styled-components';
import { useSettings } from '@wu/widget-core';
import { Bubble } from '../bubble';
import { Window } from '../window';

export const Main = () => {
  const { position, font } = useSettings();
  const [container, setContainer] = useState<Element | null>(null);

  return (
    <MainComponent>
      <Container ref={setContainer} _font={font?.value}>
        <Window />
        {position !== 'embed-chat' && (
          <Bubble portalContainerElement={container || document.body} />
        )}
      </Container>
    </MainComponent>
  );
};

const Container = styled.div<{ _font?: string }>`
  position: relative;
  width: 100%;
  height: 100%;

  & * {
    box-sizing: border-box;
  }

  ${({ _font }) => !!_font && `font-family: ${_font};`}
`;

// нужен для корректного отображения превью
const MainComponent = styled.div``;
